import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-green-button',
  templateUrl: './green-button.component.html',
  styleUrls: ['./green-button.component.css'],
})
export class GreenButtonComponent {
  @Input() label: string;
  @Output() clicked = new EventEmitter<void>();
  @Input() showArrow: boolean = false;
  @Input() showPlus: boolean = false;
  @Input() width: String = '267px';
  @Input() height: String = '70px';
  @Input() iconBefore: boolean = false;
  @Input() iconClassName: String;
  @Input() iconColor: String;
  @Input() iconSize: String;
  @Input() iconMargin: String = this.iconBefore ? '0 8px 0 0' : '0 0 0 8px';

  onClick() {
    this.clicked.emit();
  }
}
